import "./TocAvailabilityNotice.css";
import { Alert, Button } from "reactstrap";
import {
  faArrowAltCircleRight,
  faKey,
  faLock,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Header from "../Header";
import { LocalDataRemover } from "./LocalDataRemover";
import { LoginByDifferentUserHandler } from "../auth/LoginByDifferentUserHandler";
import Auth from "../auth/Auth";
import { CyApp } from "../CyApp";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface Props {
  auth: Auth;
}

export function LocalStorageDeletionNecessaryNotice(props: Props) {
  const { t } = useTranslation();

  const navigate = useNavigate();
  function deleteCachesAndReload() {
    new LocalDataRemover().removeAllLocalData().then(() => {
      //persist the new subject, *after* the user has accepted to delete the old one.
      LoginByDifferentUserHandler.persistCurrentAuth0Subject(
        props.auth.getAuth0Subject(),
      );

      window.location.reload();
    });
  }

  return (
    <>
      <Header />
      <br />
      <Alert color="warning" fade={false}>
        <h2 className={"light-header"} data-cy={CyApp.UserChangedTitle}>
          <FontAwesomeIcon icon={faKey} /> {t("auth.userChangedTitle")}
        </h2>
        <br />
        {t("auth.userChangedDesc1")}
        <br /> <br />
        {t("auth.userChangedDesc2")}
        <br /> <br />
        {t("auth.userChangedDesc3")}
        <br /> <br />
        <Button
          color="primary"
          onClick={() => props.auth.logout(navigate)}
          className="me-2"
        >
          <FontAwesomeIcon icon={faLock} /> {t("auth.logout")}
        </Button>
        <Button
          color="primary"
          onClick={() => deleteCachesAndReload()}
          data-cy={CyApp.UserChangedContinueButton}
        >
          <FontAwesomeIcon icon={faArrowAltCircleRight} />{" "}
          {t("common.buttons.continue")}
        </Button>
      </Alert>
    </>
  );
}
